import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteHealthCareRoom,
    getAllHealthCareRoomByType,
    getHealthCareRoomByCurrentUser,
    getHealthCareRoomById,
    getStaffRoomByCurrentUser,
    pagingHealthCareRoom,
    saveOrUpdateHealthCareRoom
} from 'app/services/HealthCareRoomService';
import { makeAutoObservable } from "mobx";

import { PAGESIZE_ALL } from "app/common/LocalConst";
import { HealthCareRoom } from "app/common/Model/HealthCareRoom";
import { toast } from "react-toastify";
import { downloadTemplateHealthCareRoom, importExcelHealthCareRoom, importExcelPatientTypeService } from "app/services/ImportExcelService";

const initializeListRoom = [
    { id: null, name: "Tất cả", roomNameWithDep: 'Tất cả' }
]

const initializeListDep = [
    { id: null, name: "Tất cả" }
]

export default class HealthCareRoomStore {
    listAllHealthCareRoom = [];
    searchHealthCareRoom = new SearchObject();
    pageHealthCareRoom = null;
    selectedHealthCareRoom = {isUsing:true};
    openFormCreateOrEdit = false;
    openConfirmDeleteHealthCareRoom = false;
    recentlyUpdated = false;
    listStaffRoom = [];
    defaultRoomIndex = 0;
    listStaffDep = [];

    constructor() {
        makeAutoObservable(this);
    }

    setSearchHealthCareRoom = (searchHealthCareRoom) => {
        this.searchHealthCareRoom = searchHealthCareRoom
    }

    getAllHealthCareRoomByType = async (type) => {
        if (this.listAllHealthCareRoom?.length === 0 || this.recentlyUpdated) {
            await getAllHealthCareRoomByType(type)
                .then(({ data }) => {
                    this.listAllHealthCareRoom = data || [];
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu thất bại");
                })
        }
    }

    getAllHealthCareRoom = () => {
        if (this.listAllHealthCareRoom?.length === 0 || this.recentlyUpdated) {
            pagingHealthCareRoom({ pageIndex: 1, pageSize: PAGESIZE_ALL })
                .then(({ data }) => {
                    this.listAllHealthCareRoom = data.content || [];
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu thất bại");
                })
        }
    }

    getHealthCareRoomByCurrentUser = () => {
        getHealthCareRoomByCurrentUser()
            .then(({ data }) => {
                this.listAllHealthCareRoom = data;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu phòng khám có lỗi");
            });
    }



    setDefaultRoomIndex = index => {
        this.defaultRoomIndex = index;
    }

    getStaffRoomByCurrentUser = async () => {
        return await getStaffRoomByCurrentUser()
            .then(({ data }) => {
                this.defaultRoomIndex = 0;
                const listRoom = [];

                for (let i = 0; i < data?.length; i++) {
                    if (data[i]?.isDefault) {
                        this.defaultRoomIndex = i + 1;
                    }
                    listRoom.push(data[i]?.room);
                }

                listRoom.unshift({
                    id: 1,
                    name: "Tất cả",
                    nameWithDep: "Tất cả"
                });

                this.listStaffRoom = listRoom;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu phòng làm việc có lỗi");
            })
    }

    

    handleSetListRoom = (arr) => {
        this.listStaffRoom = [...initializeListRoom, ...arr];
    }
    handleSetListDep = (arr) => {
        this.listStaffDep = [...initializeListDep, ...arr];
    }

    pagingHealthCareRoom = () => {
        pagingHealthCareRoom(this.searchHealthCareRoom)
            .then(({ data }) => {
                this.pageHealthCareRoom = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu phòng khám có lỗi");
            });
    }

    handleChangeFormSearch = (searchHealthCareRoom) => {
        this.searchHealthCareRoom = { ...this.searchHealthCareRoom, ...searchHealthCareRoom };
        this.pagingHealthCareRoom();
    }

    handleOpenFormCreateOrEdit = (healthCareRoomId) => {
        if (Boolean(healthCareRoomId)) {
            getHealthCareRoomById(healthCareRoomId).then(({ data }) => {
                this.selectedHealthCareRoom = { ...data, roomType: data.roomType == 0 ? '0' : data?.roomType };
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                console.error(error);
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedHealthCareRoom = new HealthCareRoom();
            this.openFormCreateOrEdit = true;
        }
    }

    saveHealthCareRoom = async (healthCareRoom, { setSubmitting }) => {

        return await saveOrUpdateHealthCareRoom(healthCareRoom)
            .then(() => {
                this.recentlyUpdated = true;
                this.selectedHealthCareRoom = null;
                toast.success("Lưu phòng khám thành công!");
                this.pagingHealthCareRoom();
                this.handleClosePopup();
                this.listAllHealthCareRoom = [];
            }).catch(function (error) {
                console.error(error);
                toast.error("Lưu phòng khám thất bại!");
            }).finally(function () {
                setSubmitting(false);
            });
    }

    handleDeleteHealthCareRoom = (healthCareRoomId) => {
        this.selectedHealthCareRoom = { id: healthCareRoomId?.id };
        this.openConfirmDeleteHealthCareRoom = true;
    }

    handleConfirmDeleteHealthCareRoom = () => deleteHealthCareRoom(this.selectedHealthCareRoom?.id)
        .then(() => {
            if (this.searchHealthCareRoom?.pageIndex > 1 && this.pageHealthCareRoom?.content?.length === 1) {
                this.searchHealthCareRoom.pageIndex -= 1;
            }
            toast.success("Xóa phòng khám thành công!");
            this.pagingHealthCareRoom();
            this.recentlyUpdated = true;
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa phòng khám thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteHealthCareRoom = false;
    }

    resetStore = () => {
        this.searchHealthCareRoom = new SearchObject();
        this.pageHealthCareRoom = null;
        this.selectedHealthCareRoom = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteHealthCareRoom = false;
    }



    //for choosing healthcare room popup in ChooseRoomPopup.jsx 
    listStaffRoom = [];
    staffRoomIdSet = null;

    isValidStaffRoom = staffRoom => {
        if (staffRoom && staffRoom?.room && staffRoom?.room?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addStaffRoom = staffRoom => {
        if (!this.isValidStaffRoom(staffRoom)) return;
        this.listStaffRoom.push(staffRoom);
        this.staffRoomIdSet.add(staffRoom?.room?.id);
    }

    defaultWorkingRoom = null;

    setDefaultWorkingRoom = staffRoom => {
        this.defaultWorkingRoom = staffRoom;
    }

    initializeListStaffRoom = staffRooms => {
        this.staffRoomIdSet = new Set();
        this.defaultWorkingRoom = null;
        if (staffRooms && staffRooms?.length > 0) {
            for (let i = 0; i < staffRooms.length; i++) {
                this.addStaffRoom(staffRooms[i]);
                if (staffRooms[i].isDefault) {
                    this.defaultWorkingRoom = staffRooms[i];
                }
            }
        }
    }

    removeStaffRoom = staffRoom => {
        if (!this.isValidStaffRoom(staffRoom)) return;
        if (this.staffRoomIdSet.has(staffRoom?.room?.id)) {
            this.staffRoomIdSet.delete(staffRoom?.room?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExistStaffRoom = staffRoom => {
        if (!this.isValidStaffRoom(staffRoom)) return;
        return this.staffRoomIdSet.has(staffRoom?.room?.id);
    }

    getStaffRoomIdSet = () => {
        return this.staffRoomIdSet;
    }

    getListStaffRoom = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listStaffRoom && this.listStaffRoom?.length > 0) {
            for (let i = 0; i < this.listStaffRoom.length; i++) {
                const staffRoom = this.listStaffRoom[i];
                if (this.isExistStaffRoom(staffRoom) && !bufferIdSet.has(staffRoom?.room?.id)) {
                    data.push(staffRoom);
                    bufferIdSet.add(staffRoom?.room?.id);
                }
            }
        }
        this.listStaffRoom = data;
        return data;
    }
    //end

    //for choosing healthcare room popup related to department 
    listRoom = [];
    roomIdSet = null;

    isValidRoom = room => {
        if (room && room?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addRoom = room => {
        if (!this.isValidRoom(room)) return;
        this.listRoom.push(room);
        this.roomIdSet.add(room?.id);
    }

    initializeListRoom = rooms => {
        this.roomIdSet = new Set();
        this.listRoom = [];
        if (rooms && rooms?.length > 0) {
            for (let i = 0; i < rooms.length; i++) {
                this.addRoom(rooms[i]);
            }
        }
    }

    removeRoom = room => {
        if (!this.isValidRoom(room)) return;
        if (this.roomIdSet.has(room?.id)) {
            this.roomIdSet.delete(room?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = room => {
        if (!this.isValidRoom(room)) return;
        return this.roomIdSet.has(room?.id);
    }

    getRoomIdSet = () => {
        return this.roomIdSet;
    }

    getListRoom = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listRoom && this.listRoom?.length > 0) {
            for (let i = 0; i < this.listRoom.length; i++) {
                const room = this.listRoom[i];
                if (this.isExist(room) && !bufferIdSet.has(room?.id)) {
                    data.push(room);
                    bufferIdSet.add(room?.id);
                }
            }
        }
        this.listRoom = data;
        return data;
    }

     handleDownloadExcelTemplate = async () => {
        try {
          const response = await downloadTemplateHealthCareRoom();
    
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "PHONG.xlsx");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        } catch (error) {
          console.error("Error downloading template:", error);
        }
      }
    //end

    SubmitExcelHealthCareRoom = (file) => {
        importExcelHealthCareRoom(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchHealthCareRoom = {
                ...this.searchHealthCareRoom,
                pageIndex:1
            }
            this.pagingHealthCareRoom()

        }).catch(() => {
            toast.error("Nhập excel thất bại")
        })
    }

}